import React from 'react';

const DesktopIcon = ({ width = 20, height = 20, color = 'currentColor' }) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.0001 0.333374H2.00008C1.26675 0.333374 0.666748 0.933374 0.666748 1.66671V9.66671C0.666748 10.4 1.26675 11 2.00008 11H6.66675L5.58008 12.6334C5.28675 13.0734 5.60008 13.6667 6.13341 13.6667H9.86675C10.4001 13.6667 10.7201 13.0734 10.4201 12.6334L9.33341 11H14.0001C14.7334 11 15.3334 10.4 15.3334 9.66671V1.66671C15.3334 0.933374 14.7334 0.333374 14.0001 0.333374ZM14.0001 8.33337H2.00008V2.33337C2.00008 1.96671 2.30008 1.66671 2.66675 1.66671H13.3334C13.7001 1.66671 14.0001 1.96671 14.0001 2.33337V8.33337Z"
      fill={color}
    />
  </svg>
);

export default DesktopIcon;
